import React from "react";
import PageShell from "../../components/layout/PageShell";

export default function Presentation() {
  return (
    <PageShell
      title="Présentation de l'École"
      subtitle="L'École de la Magistrature : excellence et intégrité au service de la justice haïtienne"
    >
      {/* Introduction */}
      <section className="ema-block">
        <h2 className="ema-h3">Notre institution</h2>
        <p className="ema-paragraph">
          L'École de la Magistrature (EMA) est l'institution publique chargée de la formation initiale et continue
          des magistrats et des greffiers en Haïti. Établie pour renforcer le système judiciaire national, elle forme
          les futurs juges de paix, les juges des tribunaux de première instance et des cours d'appel, ainsi que
          les greffiers qui accompagnent le fonctionnement de la justice.
        </p>
        <p className="ema-paragraph" style={{ marginTop: 12 }}>
          Notre mission est de garantir l'excellence professionnelle, l'intégrité morale et l'indépendance judiciaire
          de nos diplômés, afin qu'ils puissent rendre justice avec équité et professionnalisme au service de la
          population haïtienne.
        </p>
      </section>

      <div className="ema-divider" />

      {/* Valeurs fondamentales */}
      <section className="ema-block">
        <h2 className="ema-h3">Nos valeurs fondamentales</h2>
        <div className="ema-grid-3" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Excellence</h3>
            <p className="ema-paragraph">
              Formation de haute qualité combinant théorie juridique, pratique professionnelle et éthique judiciaire.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Intégrité</h3>
            <p className="ema-paragraph">
              Renforcement des valeurs morales, de la probité et de la déontologie chez les magistrats.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Indépendance</h3>
            <p className="ema-paragraph">
              Garantie de l'autonomie judiciaire et du respect de la séparation des pouvoirs.
            </p>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Objectifs */}
      <section className="ema-block">
        <h2 className="ema-h3">Nos objectifs</h2>
        <div className="ema-timeline" style={{ marginTop: 14 }}>
          <Timeline n="1" title="Formation professionnelle" text="Former des magistrats compétents et éthiques pour toutes les juridictions." />
          <Timeline n="2" title="Renforcement des capacités" text="Développer les compétences techniques et humaines des professionnels de la justice." />
          <Timeline n="3" title="Modernisation" text="Adapter la formation aux évolutions du droit et aux besoins de la société." />
          <Timeline n="4" title="Impact sociétal" text="Contribuer à un système judiciaire plus efficace, accessible et équitable." />
        </div>
      </section>

      <div className="ema-divider" />

      {/* Engagement */}
      <section className="ema-block">
        <h2 className="ema-h3">Notre engagement</h2>
        <p className="ema-paragraph">
          L'EMA s'engage à former des magistrats capables de :
        </p>
        <ul className="ema-list" style={{ marginTop: 12 }}>
          <li>Appliquer rigoureusement la loi avec impartialité</li>
          <li>Rédiger des décisions de qualité et motivées</li>
          <li>Gérer les dossiers avec efficacité et respect des délais</li>
          <li>Respecter les droits fondamentaux des justiciables</li>
          <li>Maintenir une conduite éthique irréprochable</li>
          <li>S'adapter aux évolutions juridiques et technologiques</li>
        </ul>
      </section>
    </PageShell>
  );
}

function Timeline({ n, title, text }) {
  return (
    <div className="ema-step">
      <div className="ema-step-num">{n}</div>
      <div className="ema-step-body">
        <h3 className="ema-h3" style={{ margin: 0 }}>{title}</h3>
        <p className="ema-paragraph" style={{ marginTop: 10 }}>{text}</p>
      </div>
    </div>
  );
}
